import { combineReducers } from 'redux';
import alertReducer from './alert.reducer';
import questionReducer from './question.reducer';
import businessCaseReducer from './businessCase.reducer';

const rootReducer = combineReducers({
  alertReducer,
  questionReducer,
  businessCase: businessCaseReducer
});

export default rootReducer;
